var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.1499L11.1831 9.33325C11.7498 9.22214 12.222 8.95547 12.5998 8.53325C12.9776 8.11103 13.1665 7.61659 13.1665 7.04992C13.1665 6.40547 12.9387 5.85547 12.4831 5.39992C12.0276 4.94436 11.4776 4.71659 10.8331 4.71659H8.2498V3.71659H10.8331C11.7554 3.71659 12.5415 4.04159 13.1915 4.69159C13.8415 5.34159 14.1665 6.1277 14.1665 7.04992C14.1665 7.73881 13.9665 8.36103 13.5665 8.91659C13.1665 9.47214 12.6442 9.88325 11.9998 10.1499ZM9.3998 7.54992L8.3998 6.54992H10.0831V7.54992H9.3998ZM13.0665 14.0666L0.549805 1.54992L1.26647 0.833252L13.7831 13.3499L13.0665 14.0666ZM6.9998 10.3333H4.16647C3.24425 10.3333 2.45814 10.0083 1.80814 9.35825C1.15814 8.70825 0.833138 7.92214 0.833138 6.99992C0.833138 6.19992 1.08036 5.49436 1.5748 4.88325C2.06925 4.27214 2.6998 3.88881 3.46647 3.73325L4.3998 4.66659H4.16647C3.52203 4.66659 2.97203 4.89436 2.51647 5.34992C2.06092 5.80547 1.83314 6.35547 1.83314 6.99992C1.83314 7.64436 2.06092 8.19436 2.51647 8.64992C2.97203 9.10547 3.52203 9.33325 4.16647 9.33325H6.9998V10.3333ZM4.91647 7.49992V6.49992H6.23314L7.23314 7.49992H4.91647Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectWallet);
export default __webpack_public_path__ + "static/media/disconnectWallet.e32db6e3dda88b30d98832227563057a.svg";
export { ForwardRef as ReactComponent };